import "bootstrap-icons/font/bootstrap-icons.css";
import { Navigate } from "react-router-dom";

import { Button, Card, DatePicker, Form, Input, InputNumber, Modal, Table } from "antd";
import dayjs from "dayjs";
import { useEffect, useState } from "react";
import { CSVLink } from "react-csv";
import { useDispatch, useSelector } from "react-redux";
import { toast } from "react-toastify";
import ColVisibilityDropdown from "../Shared/ColVisibilityDropdown";

import {
	editManualAttendance,
	loadAllAttendancePaginated,
	saveCheckOutTime
} from "../../redux/rtk/features/attendance/attendanceSlice";

import { getAllOvertime } from "../../redux/rtk/features/overtime/overtimeSlice";
import { VioletLinkBtn } from "../UI/AllLinkBtn";
import BtnSearchSvg from "../UI/Button/btnSearchSvg";
import { CsvLinkBtn, TableHeraderh2 } from "../UI/CsvLinkBtn";

import {
	TimePicker
} from "antd";
import moment from "moment";

import Search from "antd/es/transfer/search";
import timezone from 'dayjs/plugin/timezone';
import utc from 'dayjs/plugin/utc';

dayjs.extend(utc);
dayjs.extend(timezone);

dayjs.tz.setDefault("Asia/Kolkata");

//Date fucntionalities
let startdate = dayjs().startOf("month");
let enddate = dayjs().endOf("month");

function CustomTable({ list, total, status, setStatus, loading, overtimeData }) {
	const [columnsToShow, setColumnsToShow] = useState([]);
	const [isModalVisible, setIsModalVisible] = useState(false);
	const [selectedRecord, setSelectedRecord] = useState(null);
	const [searchText, setSearchText] = useState('');
	const [filteredList, setFilteredList] = useState([]);
	const [isCheckoutMode, setIsCheckoutMode] = useState(false);
	const [form] = Form.useForm();

	const dispatch = useDispatch();

	const [outTimeDate, setOutTimeDate] = useState({
		time: null,
		date: null,
	});
	const [inTimeDate, setInTimeDate] = useState({
		time: null,
		date: null,
	});

	const outTimeDateNew = outTimeDate.date && outTimeDate.time
		? new Date(Date.UTC(
			outTimeDate.date.split('-')[0],
			outTimeDate.date.split('-')[1] - 1,
			outTimeDate.date.split('-')[2],
			...outTimeDate.time.split(':').map(Number)
		))
		: null;

	const inTimeDateNew = inTimeDate.date && inTimeDate.time
		? new Date(Date.UTC(
			inTimeDate.date.split('-')[0],
			inTimeDate.date.split('-')[1] - 1,
			inTimeDate.date.split('-')[2],
			...inTimeDate.time.split(':').map(Number)
		))
		: null;

	const onChange = (value) => {
		setStatus(value);
		dispatch(
			loadAllAttendancePaginated({
				page: 1,
				limit: 10,
				startdate,
				enddate,
			})
		);
	};


	const columns = [
		{
			id: 1,
			title: "S.No",
			dataIndex: "serial",
			key: "serial",
		},
		{
			id: 10,
			title: "User",
			dataIndex: "user",
			key: "user",
			render: (user) => `${user?.firstName || ''} ${user?.lastName || ''}`.trim(),
		},
		{
			title: "In Time",
			dataIndex: "inTime",
			key: "inTime",
			render: (inTime) => dayjs(inTime).utc().format("DD-MM-YYYY, HH:mm A"),
		},
		{
			title: "Out Time",
			dataIndex: "outTime",
			key: "outTime",
			render: (outTime) => {
				if (!outTime || isNaN(dayjs(outTime).valueOf())) return "N/A";
				return dayjs(outTime).utc().format("DD-MM-YYYY, HH:mm A");
			},
		},

		// {
		// 	id: 4,
		// 	title: "In Status",
		// 	dataIndex: "inTimeStatus",
		// 	key: "inTimeStatus",
		// 	render: (inTimeStatus) => {
		// 		if (inTimeStatus === "Late") {
		// 			return <Tag color='red'>{inTimeStatus.toUpperCase()}</Tag>;
		// 		} else if (inTimeStatus === "Early") {
		// 			return <Tag color='blue'>{inTimeStatus.toUpperCase()}</Tag>;
		// 		} else if (inTimeStatus === "On Time") {
		// 			return <Tag color='green'>{inTimeStatus.toUpperCase()}</Tag>;
		// 		} else {
		// 			return <Tag style={{ color: "orange" }}>NONE</Tag>;
		// 		}
		// 	},
		// },
		// {
		// 	id: 5,
		// 	title: "Out Status",
		// 	dataIndex: "outTimeStatus",
		// 	key: "outTimeStatus",
		// 	render: (outTimeStatus) => {
		// 		// use Tag component from antd to show status in different colors like green, red, yellow etc based on the status value
		// 		if (outTimeStatus === "Late") {
		// 			return <Tag color='red'>{outTimeStatus.toUpperCase()}</Tag>;
		// 		} else if (outTimeStatus === "Early") {
		// 			return <Tag color='blue'>{outTimeStatus.toUpperCase()}</Tag>;
		// 		} else if (outTimeStatus === "On Time") {
		// 			return <Tag color='green'>{outTimeStatus.toUpperCase()}</Tag>;
		// 		} else {
		// 			return <Tag style={{ color: "orange" }}>NONE</Tag>;
		// 		}
		// 	},
		// },
		{
			id: 6,
			title: "Work Hour",
			dataIndex: "finalWorkingHours",
			key: "finalWorkingHours",
			render: (finalWorkingHours) => {
				if (!finalWorkingHours) return "Not Checked";

				const hours = Math.floor(finalWorkingHours);
				const minutes = Math.round((finalWorkingHours - hours) * 60);

				// Format hours and minutes to always show two digits
				const formattedTime = `${String(hours).padStart(2, '0')}:${String(minutes).padStart(2, '0')}`;

				return formattedTime;
			},
		},

		// {
		// 	id: 6,
		// 	title: "Work Hour",
		// 	dataIndex: "totalHour",
		// 	key: "totalHour",
		// 	render: (totalHour) => totalHour ? totalHour.toFixed(2) : "Not Checked",
		// },
		{
			id: 7,
			title: "Break Hour",
			dataIndex: "totalBreakHours",
			key: "totalBreakHours",
			render: (totalBreakHours) => totalBreakHours ? totalBreakHours.toFixed(2) : "Not Checked",
		},
		{
			id: 7,
			title: "Punch By",
			dataIndex: "punchByUser",
			key: "punchByUser",
			render: (punchByUser) => {
				return punchByUser
					? `${punchByUser.firstName || ''} ${punchByUser.lastName || ''}`.trim()
					: "N/A";
			},
		},
		{
			id: 7,
			title: " Task ",
			dataIndex: "checkOutComment",
			key: "checkOutComment",
			render: (text) => {
				return text ? text : "N/A"
			}
		},
		// {
		// 	id: 8,
		// 	title: "Overtime (Hours)",
		// 	dataIndex: "userId",
		// 	key: "overtime",
		// 	render: (userId) => {
		// 		// Filter overtime data based on userId and selected date range
		// 		const userOvertime = overtimeData.filter(overtime =>
		// 			overtime.userId === userId &&
		// 			dayjs(overtime.date).isBetween(startdate, enddate, null, "[]") // Check date range
		// 		);

		// 		// Calculate total overtime hours for the user within the date range
		// 		const totalOvertime = userOvertime.reduce((acc, curr) => acc + (curr.overtimeLength || 0), 0);

		// 		return totalOvertime > 0 ? totalOvertime.toFixed(2) : "No Overtime";
		// 	},
		// },
		// 

		{
			id: 9,
			title: "Action",
			key: "action",
			render: (_, record) => {
				return (
					<div style={{ display: "flex", justifyContent: 'space-between' }}>
						{/* Existing Check-Out Button */}
						{!record.outTime ? (
							<button
								style={{
									padding: "4px 8px",
									backgroundColor: "#FF5733",
									color: "white",
									border: "none",
									borderRadius: "5px",
									cursor: "pointer",
									fontSize: "14px",
								}}
								onClick={() => handleCheckOut(record)}
							>
								Check Out
							</button>
						) : (
							<span style={{ color: "#4CAF50", fontSize: "14px", fontWeight: "bold" }}>
								Already Checked Out
							</span>
						)}
						{/* New Edit Button */}
						<button
							style={{
								padding: "4px 8px",
								backgroundColor: "#007BFF",
								color: "white",
								border: "none",
								borderRadius: "5px",
								cursor: "pointer",
								fontSize: "14px",
							}}
							onClick={() => handleEditAttendance(record)}
						>
							Edit
						</button>
					</div>
				);
			},
		}
	];

	const handleEditAttendance = (record) => {
		setIsCheckoutMode(false);
		setSelectedRecord(record);
		console.log("record", record);

		const inTimeMoment = dayjs.utc(record.inTime);
		const outTimeMoment = record.outTime ? dayjs.utc(record.outTime) : null;

		form.setFieldsValue({
			...record,
			user: `${record.user.firstName} ${record.user.lastName}`,
			inTime: inTimeMoment,
			outTime: outTimeMoment,
			totalBreakHours: record.totalBreakHours,
		});

		// Explicitly set date and time states
		setInTimeDate({
			date: inTimeMoment.format('YYYY-MM-DD'),
			time: inTimeMoment.format('HH:mm')
		});

		// if (outTimeMoment) {
		setOutTimeDate({
			date: outTimeMoment ? outTimeMoment.format('YYYY-MM-DD') : null,
			// time: outTimeMoment.format('HH:mm')
			time: outTimeMoment ? outTimeMoment.format('HH:mm') : null

		});
		// }

		setIsModalVisible(true);
	};

	const handleCheckOut = (record) => {
		setSelectedRecord(record);
		setIsModalVisible(true);
		setIsCheckoutMode(true);
		form.setFieldsValue({
			...record,
			user: `${record.user.firstName} ${record.user.lastName}`,
			inTime: dayjs.utc(record.inTime),
			outTime: record.outTime ? dayjs(record.outTime) : null,
			punchBy: `${record.punchByUser.firstName} ${record.punchByUser.lastName}`,
			totalBreakHours: record.totalBreakHours,

		});
	};

	const handleModalCancel = () => {
		setIsModalVisible(false);
		setSelectedRecord(null);
		form.resetFields();
	};


	const handleModalSubmit = async () => {
		try {
			const values = await form.validateFields();

			if (isCheckoutMode) {
				// Checkout logic
				const outTime = outTimeDateNew;
				const inTime = inTimeDateNew;

				// Validate out time
				if (outTime && dayjs(outTime).isBefore(dayjs(selectedRecord.inTime))) {
					toast.error("Out time cannot be earlier than In time.");
					return;
				}

				const checkoutPayload = {
					id: selectedRecord.id,
					attendanceId: selectedRecord.id,
					userId: selectedRecord.userId,
					outTime: outTime instanceof Date && !isNaN(outTime)
						? outTime
						: outTime
							? dayjs(outTime).toDate()
							: null,
					checkOutComment: values.checkOutComment,
					totalBreakHours: values.totalBreakHours,
				};

				const resultAction = await dispatch(saveCheckOutTime(checkoutPayload));

				if (saveCheckOutTime.fulfilled.match(resultAction)) {
					toast.success("Checked out successfully");
					// dispatch(loadAttendanceByUserId(id));
					dispatch(loadAllAttendancePaginated({ page: 1, limit: 10, startdate, enddate, }));
				} else {
					toast.error("Failed to check out");
				}
			} else {
				// Edit logic
				const editPayload = {
					id: selectedRecord.id,
					userId: selectedRecord.userId,
					inTime: values.inTime ? dayjs(values.inTime).toDate() : null,
					outTime: outTimeDateNew ? dayjs(outTimeDateNew).toDate() : null,
					totalBreakHours: values.totalBreakHours,
					checkOutComment: values.checkOutComment,
				};

				const resultAction = await dispatch(editManualAttendance({ values: editPayload, id: selectedRecord.id }));

				if (editManualAttendance.fulfilled.match(resultAction)) {
					toast.success("Attendance updated successfully");
					// dispatch(loadAttendanceByUserId(id));
					dispatch(loadAllAttendancePaginated({ page: 1, limit: 10, startdate, enddate, }));

				} else {
					toast.error("Failed to update attendance");
				}
			}

			setIsModalVisible(false);
			form.resetFields();
		} catch (info) {
			console.error("Validate Failed:", info);
		}
	};


	// const handleCheckOut = (record) => {
	// 	setSelectedRecord(record);
	// 	form.setFieldsValue({
	// 		...record,
	// 		user: `${record.user.firstName} ${record.user.lastName}`,
	// 		inTime: dayjs(record.inTime),
	// 		outTime: record.outTime ? dayjs(record.outTime) : null,
	// 		// punchBy: record.punchBy[0]?.firstName + " " + record.punchBy[0]?.lastName,
	// 		punchBy: `${record.punchByUser.firstName} ${record.punchByUser.lastName}`,
	// 		totalBreakHours: record.totalBreakHours,

	// 	});
	// 	setIsModalVisible(true);
	// };

	// const handleModalCancel = () => {
	// 	setIsModalVisible(false);
	// 	setSelectedRecord(null);
	// 	form.resetFields();
	// };

	// const handleModalSubmit = async () => {
	// 	try {
	// 		const values = await form.validateFields();
	// 		console.log("Updated values:", values);
	// 		const inTime = values.inTime;
	// 		const outTime = outTimeDateNew;

	// 		// Log the totalBreakHours value
	// 		console.log("Total Break Hours: ", values.totalBreakHours);

	// 		if (outTime && inTime && dayjs(outTime).isBefore(dayjs(inTime))) {
	// 			toast.error("Out time cannot be earlier than In time.");
	// 			return;
	// 		}

	// 		const resultAction = await dispatch(saveCheckOutTime({
	// 			id: selectedRecord.userId,
	// 			outTime: outTime instanceof Date && !isNaN(outTime) ? outTime : null,
	// 			checkOutComment: values.checkOutComment,
	// 			totalBreakHours: values.totalBreakHours,
	// 		}));

	// 		if (saveCheckOutTime.fulfilled.match(resultAction)) {
	// 			dispatch(
	// 				loadAllAttendancePaginated({
	// 					page: 1,
	// 					limit: 10,
	// 					startdate,
	// 					enddate,
	// 				})
	// 			);
	// 		} else {
	// 			toast.error("Failed to save check-out time.");
	// 		}
	// 		setIsModalVisible(false);
	// 		form.resetFields();
	// 	} catch (info) {
	// 		console.error("Validate Failed:", info);
	// 	}
	// };


	useEffect(() => {
		setColumnsToShow(columns);
	}, []);

	const columnsToShowHandler = (val) => {
		setColumnsToShow(val);
	};

	const addKeys = (arr) => arr.map((i, index) => ({ ...i, key: i.id, serial: index + 1 }));


	const CSVlist = list?.map((i) => ({
		...i,
		supplier: i?.supplier?.name,
	}));

	useEffect(() => {
		if (list) {
			const filtered = list.filter(item => {
				const fullName = `${item.user?.firstName} ${item.user?.lastName}`.toLowerCase();
				return fullName.includes(searchText.toLowerCase());
			});
			setFilteredList(filtered);
		}
	}, [list, searchText]);
	const formatWorkHours = (finalWorkingHours) => {
		if (!finalWorkingHours) return "Not Checked";
		const hours = Math.floor(finalWorkingHours);
		const minutes = Math.round((finalWorkingHours - hours) * 60);
		return `${String(hours).padStart(2, '0')}:${String(minutes).padStart(2, '0')}`;
	};

	const csvData = list.map((item, index) => ({
		S_No: index + 1,
		User: `${item.user?.firstName || ""} ${item.user?.lastName || ""}`,
		In_Time: item.inTime ? dayjs(item.inTime).utc().format("DD-MM-YYYY, HH:mm A") : "N/A",
		Out_Time: item.outTime ? dayjs(item.outTime).utc().format("DD-MM-YYYY, HH:mm A") : "N/A",
		Work_Hour: formatWorkHours(item.finalWorkingHours),
		totalBreakHours: item.totalBreakHours ? item.totalBreakHours.toFixed(2) : "N/A",
		Punch_By: `${item.punchByUser?.firstName || ""} ${item.punchByUser?.lastName || ""}`,
		task:`${item.checkOutComment || "N/A"}` 

	}));

	const headers = [
		{ label: "S.No", key: "S_No" },
		{ label: "User", key: "User" },
		{ label: "In Time", key: "In_Time" },
		{ label: "Out Time", key: "Out_Time" },
		{ label: "Work Hour", key: "Work_Hour" },
		{ label: "Break Hour", key: "totalBreakHours" },
		{ label: "Punch By", key: "Punch_By" },
		{ label: "Task", key: "task" },

	];

	return (
		<div className='mt-5'>
			{list && (
				<div className='text-center my-2 flex justify-end'>
					<div className="mb-4">
						<Search
							placeholder="Search by name..."
							allowClear
							// enterButton="Search"
							size="large"
							onChange={(e) => setSearchText(e.target.value)}
							style={{ maxWidth: '400px' }}
						/>
					</div>
					<CsvLinkBtn>
						<CSVLink
							data={csvData}
							headers={headers}
							filename={`attendance_${dayjs().format("YYYY-MM-DD")}.csv`}
							className="btn btn-primary"
							target="_blank"
						>
							Download CSV
						</CSVLink>
					</CsvLinkBtn>

				</div>
			)}

			{list && (
				<div style={{ marginBottom: "30px" }}>
					<ColVisibilityDropdown
						options={columns}
						columns={columns}
						columnsToShowHandler={columnsToShowHandler}
					/>
				</div>
			)}

			<Table
				scroll={{ x: true }}
				loading={loading}
				columns={columnsToShow}
				dataSource={filteredList ? addKeys(filteredList) : []}
			/>

			<Modal
				// title="Checkout Details"
				title={isCheckoutMode ? "Checkout Details" : "Edit Attendance"}
				visible={isModalVisible}
				onCancel={handleModalCancel}
				footer={[
					<Button key="cancel" onClick={handleModalCancel}>
						Cancel
					</Button>,
					<Button key="submit" type="primary" onClick={handleModalSubmit}>
						{isCheckoutMode ? "Check Out" : "Update"}
					</Button>,
				]}
			>
				<Form form={form} layout="vertical">

					<Form.Item
						label="User"
						name="user"
						rules={[{ required: true, message: "User is required" }]}
					>
						<Input disabled />
					</Form.Item>
					<Form.Item
						label="In Time"
						name="inTime"
						rules={[{ required: true, message: "In Time is required" }]}
					>

						<div className='flex justify-between'>
							{/* <DatePicker
											format={"YYYY-MM-DD"}
											disabled={isCheckoutMode}
											onChange={(date, dateString) =>
												setInTimeDate({ ...inTimeDate, date: dateString })
											}
										/>
										<TimePicker
											className='ml-4'
											format={"HH:mm"}
											disabled={isCheckoutMode}
											onChange={(time, timeString) =>
												setInTimeDate({ ...inTimeDate, time: timeString })
											}
										/> */}
							<DatePicker
								value={form.getFieldValue('inTime') ? dayjs(form.getFieldValue('inTime')) : null}
								format={"YYYY-MM-DD"}
								disabled={isCheckoutMode}
								onChange={(date, dateString) => {
									setInTimeDate({ ...inTimeDate, date: dateString });
									form.setFieldsValue({ inTime: date });
								}}
								showToday={false}
							/>

							<TimePicker
								value={form.getFieldValue('inTime') ? dayjs(form.getFieldValue('inTime')) : null}
								className='ml-4'
								format={"HH:mm"}
								disabled={isCheckoutMode}
								onChange={(time, timeString) => {
									setInTimeDate({ ...inTimeDate, time: timeString });
									form.setFieldsValue({ inTime: time });
								}}
								showNow={false}
							/>
						</div>
					</Form.Item>


					<Form.Item
						style={{ marginBottom: "10px" }}
						label='End Time'
					>
						<div className='flex justify-between'>
							{/* <DatePicker
											format={"YYYY-MM-DD"}
											onChange={(date, dateString) =>
												setOutTimeDate({ ...outTimeDate, date: dateString })
											}
										/>
										<TimePicker
											className='ml-4'
											format={"HH:mm"}
											onChange={(time, timeString) =>
												setOutTimeDate({ ...outTimeDate, time: timeString })
											}
										/> */}
							<DatePicker
								value={form.getFieldValue('outTime') ? dayjs(form.getFieldValue('outTime')) : null}
								format={"YYYY-MM-DD"}
								onChange={(date, dateString) => {
									setOutTimeDate({ ...outTimeDate, date: dateString });
									form.setFieldsValue({ outTime: date });
								}}
								showToday={false}
							/>
							<TimePicker
								value={form.getFieldValue('outTime') ? dayjs(form.getFieldValue('outTime')) : null}
								className='ml-4'
								format={"HH:mm"}
								onChange={(time, timeString) => {
									setOutTimeDate({ ...outTimeDate, time: timeString });
									form.setFieldsValue({ outTime: time });
								}}
								showNow={false}
							/>
						</div>
					</Form.Item>
					<Form.Item
						style={{ marginBottom: "10px" }}
						label='Total Break Hours'
						name='totalBreakHours'>
						<InputNumber placeholder='Total Break Hours' />
					</Form.Item>
					<Form.Item
						label="Task"
						name="checkOutComment"
					>
						<Input.TextArea rows={3} placeholder="Enter your task here" />
					</Form.Item>
					{/* <Form.Item
									label="Punch By"
									name="punchBy"
								>
									<Input disabled />
								</Form.Item> */}
				</Form>
			</Modal>
		</div>
	);
}

const GetAllAttendance = (props) => {
	const dispatch = useDispatch();

	const { list, loading } = useSelector((state) => state.attendance);
	const [status, setStatus] = useState("true");
	const overtimeData = useSelector((state) => state.overtime.list);
	console.log("overtimeData", overtimeData);


	// const [total, setTotal] = useState(0);

	const { RangePicker } = DatePicker;

	useEffect(() => {
		dispatch(
			loadAllAttendancePaginated({
				page: 1,
				limit: 10,
				startdate,
				enddate,
			})
		);

		dispatch(getAllOvertime())

	}, []);

	const onCalendarChange = (dates) => {
		// startdate = dayjs((dates?.[0]).format("DD-MM-YYYY"));
		// enddate = dayjs((dates?.[1]).format("DD-MM-YYYY"));
		startdate = (dates?.[0]) ? dayjs(dates[0]).toDate() : null;
		enddate = (dates?.[1]) ? dayjs(dates[1]).endOf('day').toDate() : null;

	};

	// Convert startdate and enddate to moment objects
	// const defaultValue = [moment(startdate), moment(enddate)];
	const defaultValue = [dayjs(startdate), moment(enddate)];


	const onClickSearch = () => {
		// dispatch(clearAttendanceList());

		dispatch(
			loadAllAttendancePaginated({
				page: 1,
				limit: 10,
				startdate,
				enddate,
			}),
		);
	};

	// TODO : Add Search functionality here

	const isLogged = Boolean(localStorage.getItem("isLogged"));

	if (!isLogged) {
		return <Navigate to={"/admin/auth/login"} replace={true} />;
	}
	return (
		<>
			{/* <Card className='card card-custom mt-3 '> */}
			<Card>
				<div className='card-body'>
					<div className='flex justify-between'>
						<TableHeraderh2>Attendance List</TableHeraderh2>
						<div className='flex justify-end'>
							<RangePicker
								onCalendarChange={onCalendarChange}
								defaultValue={defaultValue}
								format={"DD-MM-YYYY"}
								className='range-picker mr-3'
								style={{ maxWidth: "400px" }}
							/>
							<VioletLinkBtn>
								<button onClick={onClickSearch}>
									<BtnSearchSvg size={25} title={"SEARCH"} loading={loading} />
								</button>
							</VioletLinkBtn>
						</div>
					</div>
					{/*TODO : ADD TOTAL AMOUNT HERE */}
					{Array.isArray(list) && (
						<CustomTable
							list={list}
							loading={loading}
							overtimeData={overtimeData}
							total={100}
							startdate={startdate}
							enddate={enddate}
							status={status}
							setStatus={setStatus}
						/>
					)}
				</div>
			</Card>
		</>
	);
};

export default GetAllAttendance;
